/* eslint-disable no-unused-expressions */
/* eslint-disable no-restricted-globals */
/* eslint-disable max-len */
import { Field, Formik } from 'formik';
import { upperFirst } from 'lodash';
import { DropdownField, RadioField, TextAreaField } from 'Modules/Formik';
import FieldDecorator from 'Modules/Formik/FieldDecorator/FieldDecorator';
import InputField from 'Modules/Formik/Input/Input';
import InputWithTypeField from 'Modules/Formik/Input/InputWithTypeField';
import Space from 'Modules/Space';
import { arrayOf, func, shape, string } from 'prop-types';
import React, { useMemo, useState } from 'react';
import { useSelector } from 'react-redux';
import { Button, Divider, Form, Grid, GridColumn, GridRow, Modal } from 'semantic-ui-react';

import SearchNotfound from '../SearchNotFound/SearchNotFound';

import styles from './AddMedicineModal.less';
import InstructionSelect from './InstructionSelect/InstructionSelect';
import MedicinePickerField from './MedicinePickerField/MedicinePickerField';
import validationSchema from './validate';

const generateOptions = (data = []) => {
  return data?.map(item => ({
    text: item.label,
    value: item.value,
  }));
};

const AddMedicineModal = props => {
  const {
    initialValues,
    templates,
    pharmacyId,
    onCancel,
    onSave,
    onAddNew,
    pharmacy,
    currencySymbol,
    serviceId,
  } = props;
  const [isNotfound, setIsNotfound] = useState(false);
  const resultSearchChange = (results, keyword) => {
    setIsNotfound(keyword && !results?.length);
  };

  const prescription = useSelector(state => state.webChat.prescription);
  const { clinicalTerm } = prescription;

  const doseUnits = useMemo(
    () => generateOptions(clinicalTerm?.medicineDosageUnit) || [],
    [clinicalTerm?.medicineDosageUnit],
  );

  const routes = useMemo(
    () => generateOptions(clinicalTerm?.medicineRouteOfAdmin) || [],
    [clinicalTerm?.medicineRouteOfAdmin],
  );
  const frequencies = useMemo(
    () => generateOptions(clinicalTerm?.medicineFrequency) || [],
    [clinicalTerm?.medicineFrequency],
  );
  const durations = useMemo(
    () => generateOptions(clinicalTerm?.durationUnit) || [],
    [clinicalTerm?.durationUnit],
  );

  return (
    <Modal
      className="medicine-modal"
      open
      size="small"
      onClose={() => onCancel()}
      closeOnDimmerClick={false}
      centered={false}
      closeIcon>
      <Modal.Header>
        {initialValues.mode === 'edit' ? 'Edit Medicine' : 'Add Medicine'}
      </Modal.Header>
      <Modal.Content>
        <div className={styles.modalConten}>
          <Formik
            initialValues={initialValues}
            validationSchema={validationSchema}
            enableReinitialize
            onSubmit={async (values, actions) => {
              try {
                await onSave(values);
              } finally {
                actions.setSubmitting(false);
              }
            }}>
            {({ handleSubmit, setFieldValue, values, isValid }) => {
              const product = values?.description?.product;
              return (
                <Form
                  onSubmit={e => {
                    e.stopPropagation();
                    handleSubmit(e);
                  }}>
                  <Field
                    label=""
                    name="description"
                    pharmacy={pharmacy}
                    pharmacyId={pharmacyId}
                    component={MedicinePickerField}
                    placeholder="Search medicine"
                    resultSearchChange={resultSearchChange}
                    templates={templates}
                    quantity={values?.quantity}
                    useCustomInstruction={values.useCustomInstruction}
                    uomUnit={values.uomUnit}
                    onChange={() => true}
                    currencySymbol={currencySymbol}
                    serviceId={serviceId}
                  />

                  {isNotfound && !values?.description ? (
                    <SearchNotfound />
                  ) : (
                    values?.description && (
                      <>
                        <Grid>
                          <GridRow>
                            <GridColumn width={6}>
                              <FieldDecorator
                                visible={
                                  values.quantity > 0 &&
                                  values.quantity > product?.availableQuantity
                                }
                                label="Insufficient stock"
                                type="warning">
                                <Field
                                  name="quantity"
                                  component={InputField}
                                  type="text"
                                  customLabel={{
                                    basic: true,
                                    content: upperFirst(values?.uomUnit ?? ''),
                                    size: 'mini',
                                  }}
                                  label="Quantity"
                                  labelPosition="right"
                                  hint={`Available Stock: ${product?.availableQuantity || 'N/A'}`}
                                  errorInline
                                  onlyTypeIntegerNumber
                                />
                              </FieldDecorator>
                            </GridColumn>
                            <GridColumn width={6}>
                              <Field
                                name="unitPrice"
                                component={InputField}
                                disabled
                                type="number"
                                value={values.description?.unitPrice}
                                customLabel={{ basic: true, content: currencySymbol }}
                                label="Unit Price"
                                labelPosition="right"
                              />
                            </GridColumn>
                            <GridColumn width={4}>
                              <Field
                                name="total"
                                component={InputField}
                                type="number"
                                value={(
                                  (values.quantity || 1) * values.description.unitPrice
                                ).toFixed(2)}
                                customLabel={{ basic: true, content: currencySymbol }}
                                labelPosition="right"
                                label="Total"
                                disabled
                              />
                            </GridColumn>
                          </GridRow>
                        </Grid>
                        <Divider />
                        <div className={styles.customMode}>
                          <Space direction="horizontal" alignItems="center">
                            <div className={styles.instructionTitle}>Instruction</div>
                            <InstructionSelect />
                          </Space>
                          <Field
                            label="Custom mode"
                            toggle
                            name="useCustomInstruction"
                            component={RadioField}
                          />
                        </div>
                        {!values.useCustomInstruction && (
                          <div>
                            <Grid>
                              <GridRow columns={2}>
                                <GridColumn>
                                  <Field
                                    name="amountPerTime"
                                    component={InputWithTypeField}
                                    type="number"
                                    prefixName="doseUnitCode"
                                    errorInline
                                    options={doseUnits}
                                    placeholder="Enter value"
                                    label="Dose"
                                    inputWidthInPercent={30}
                                  />
                                </GridColumn>
                                <GridColumn>
                                  <Field
                                    name="routeCode"
                                    component={DropdownField}
                                    options={routes}
                                    label="Route"
                                    placeholder="Select route"
                                    search
                                    clearable
                                  />
                                </GridColumn>
                              </GridRow>
                              <GridRow columns={2}>
                                <GridColumn>
                                  <Field
                                    name="frequencyCode"
                                    component={DropdownField}
                                    options={frequencies}
                                    label="Frequency"
                                    placeholder="Select frequency"
                                    errorInline
                                    search
                                  />
                                </GridColumn>
                                <GridColumn>
                                  <Field
                                    name="duration"
                                    component={InputWithTypeField}
                                    type="number"
                                    prefixName="durationUnitCode"
                                    options={durations}
                                    label="Duration"
                                  />
                                </GridColumn>
                              </GridRow>
                            </Grid>
                          </div>
                        )}
                        <div className={styles.rowField}>
                          <Field
                            label="Note"
                            name="note"
                            maxlengthchar={500}
                            component={TextAreaField}
                            placeholder="Add note"
                            errorInline
                          />
                        </div>
                        <div className={styles.templateContainer}>
                          {templates &&
                            templates.map(item => (
                              <div
                                key={item.id}
                                className={styles.templateItem}
                                onClick={() => {
                                  const newText = values.note
                                    ? `${values.note} ${item.template}`
                                    : item.template;
                                  setFieldValue('note', newText.slice(0, 500));
                                }}>
                                {item.template}
                              </div>
                            ))}
                        </div>

                        <div style={{ display: 'flex', justifyContent: 'end' }}>
                          <div className={styles.actionContainer}>
                            <Button type="submit" className={styles.cancel}>
                              Done
                            </Button>

                            <Button
                              type="button"
                              primary
                              onClick={async e => {
                                await handleSubmit(e);
                                if (isValid) {
                                  onAddNew();
                                }
                              }}>
                              Save & Add more
                            </Button>
                          </div>
                        </div>
                      </>
                    )
                  )}
                </Form>
              );
            }}
          </Formik>
        </div>
      </Modal.Content>
    </Modal>
  );
};

AddMedicineModal.propTypes = {
  initialValues: shape({}).isRequired,
  templates: arrayOf(shape({})).isRequired,
  pharmacyId: string.isRequired,
  onCancel: func.isRequired,
  onSave: func.isRequired,
  onAddNew: func.isRequired,
  pharmacy: shape({}),
  currencySymbol: string.isRequired,
  serviceId: string,
};

AddMedicineModal.defaultProps = {
  pharmacy: {},
};

export default AddMedicineModal;
